<template>
  <div class="hour-audit-page">
    <h2 class="page-title">课时对账</h2>
    <p class="page-desc">核对学员账面课时与充值/消耗流水是否一致（大课、小课分开统计）</p>

    <el-card>
      <div class="toolbar">
        <el-input
          v-model="keyword"
          placeholder="搜索学生/家长/电话"
          clearable
          @clear="loadData"
          @keyup.enter.native="loadData"
        >
          <el-button slot="append" icon="el-icon-search" @click="loadData" />
        </el-input>
      </div>

      <el-table :data="list" v-loading="loading" border stripe @row-click="openDetail">
        <el-table-column prop="studentName" label="学生" width="100" />
        <el-table-column prop="parentName" label="家长" width="100" />
        <el-table-column prop="parentPhone" label="电话" width="130" />
        <el-table-column label="大课" width="100">
          <template slot-scope="{ row }">
            <el-tag :type="row.group && row.group.consistent ? 'success' : 'danger'" size="small">
              {{ row.group && row.group.consistent ? '一致' : '异常' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="小课" width="100">
          <template slot-scope="{ row }">
            <el-tag :type="row.privateCourse && row.privateCourse.consistent ? 'success' : 'info'" size="small">
              {{ !row.privateCourse || (row.privateCourse.totalHours === 0 && row.privateCourse.enrollmentSum === 0) ? '无' : (row.privateCourse.consistent ? '一致' : '异常') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="大课剩余" width="90">
          <template slot-scope="{ row }">{{ row.group ? row.group.remainingHours : 0 }}</template>
        </el-table-column>
        <el-table-column label="小课剩余" width="90">
          <template slot-scope="{ row }">{{ row.privateCourse ? row.privateCourse.remainingHours : 0 }}</template>
        </el-table-column>
        <el-table-column label="操作" width="90">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click.stop="openDetail(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="margin-top: 16px"
        @current-change="handlePageChange"
        :current-page="page"
        :page-size="size"
        :total="total"
        layout="total, prev, pager, next"
      />
    </el-card>

    <el-dialog title="课时对账详情" :visible.sync="detailVisible" width="720px" top="5vh">
      <div v-if="current">
        <h3>{{ current.studentName }} · {{ current.parentName }} {{ current.parentPhone }}</h3>
        <div class="audit-block">
          <h4>大课</h4>
          <audit-panel :audit="current.group" />
        </div>
        <div class="audit-block">
          <h4>小课</h4>
          <audit-panel :audit="current.privateCourse" />
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { searchHourAudit } from '../api'

const AuditPanel = {
  props: { audit: Object },
  template: `
    <div v-if="audit">
      <el-tag :type="audit.consistent ? 'success' : 'danger'" size="small" style="margin-bottom:12px">
        {{ audit.consistent ? '账目一致' : '存在差异' }}
      </el-tag>
      <el-descriptions :column="2" border size="small">
        <el-descriptions-item label="账面总课时">{{ audit.totalHours }}</el-descriptions-item>
        <el-descriptions-item label="充值流水合计">{{ audit.enrollmentSum }}</el-descriptions-item>
        <el-descriptions-item label="账面已用">{{ audit.usedHours }}</el-descriptions-item>
        <el-descriptions-item label="消耗流水合计">{{ audit.consumedSum }}</el-descriptions-item>
        <el-descriptions-item label="账面剩余">{{ audit.remainingHours }}</el-descriptions-item>
        <el-descriptions-item label="账面欠课">{{ audit.owedHours }}</el-descriptions-item>
        <el-descriptions-item label="欠费记录合计">{{ audit.owedRecordSum }}</el-descriptions-item>
        <el-descriptions-item label="余额校验">{{ audit.owedHours > 0 ? '有欠课，不适用' : (audit.balanceFormulaOk ? '总-已用=剩余 ✓' : '总-已用≠剩余') }}</el-descriptions-item>
      </el-descriptions>
      <ul v-if="audit.issues && audit.issues.length" class="issue-list">
        <li v-for="(item, i) in audit.issues" :key="i">{{ item }}</li>
      </ul>
      <p v-else-if="audit.totalHours === 0 && audit.enrollmentSum === 0" class="muted">暂无大课/小课数据</p>
    </div>
  `
}

export default {
  name: 'HourAudit',
  components: { AuditPanel },
  data() {
    return {
      keyword: '',
      list: [],
      page: 1,
      size: 20,
      total: 0,
      loading: false,
      detailVisible: false,
      current: null
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      try {
        const res = await searchHourAudit({ keyword: this.keyword, page: this.page, size: this.size })
        this.list = res.data.records || []
        this.total = res.data.total || 0
      } finally {
        this.loading = false
      }
    },
    handlePageChange(p) {
      this.page = p
      this.loadData()
    },
    openDetail(row) {
      this.current = row
      this.detailVisible = true
    }
  }
}
</script>

<style scoped>
.page-title { margin-bottom: 8px; }
.page-desc { color: #64748B; font-size: 14px; margin-bottom: 20px; }
.toolbar { margin-bottom: 16px; }
.toolbar .el-input { max-width: 360px; width: 100%; }
.audit-block { margin-top: 20px; }
.audit-block h4 { margin-bottom: 10px; color: #334155; }
.issue-list { margin-top: 12px; padding-left: 20px; color: #DC2626; font-size: 13px; line-height: 1.6; }
.muted { color: #94A3B8; font-size: 13px; margin-top: 8px; }
</style>
